export default __webpack_public_path__ + "static/media/Notifications_NewOffer.715868ba.svg";